export const SET_APPLICATION_STEP = 'SET_APPLICATION_STEP';
